
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2376|4568|8380)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
